module.exports = "/assets/festival-menu-banner-fdw.png?hsKRtqz";